class ProductInventory extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const self = this;
    self._init();
    // document.addEventListener("variant:changed", self._updateMessaging.bind(self));
    document.addEventListener('inventoryInfo.appRendered', self._updateMessaging.bind(self));
  }
  _init() {
    const self = this;
    self._setLocationObject()
  }
  _setLocationObject() {
    const self = this;
    if (inventoryInfo) {
      window.variantLocations = inventoryInfo[inventoryInfo.api.getProductIdentifiers().handle].variantLocations;
      const currentVariantId = parseInt(self.dataset.currentVariantId, 10);
      const locationObject = self._getLocationObject(currentVariantId);
      self._getMessaging(locationObject);
    } else {
      setTimeout(self._setLocationObject.bind(self), 250);
    }
  }
  _updateMessaging(e) {
    const self = this;
    const variant_id = e.detail ? e.detail : inventoryInfo.api.getProductIdentifiers().variant;
    self.dataset.currentVariantId = variant_id;
    const locationObject = self._getLocationObject(variant_id);
    self._getMessaging(locationObject);
  }
  _getMessaging(locationObject) {
    const self = this;
    if (locationObject) {
      const { variantSupplier } = self.dataset;
      for (let i = 0; i < locationObject.inventoryLocations.length; i++) {
        const location = locationObject.inventoryLocations[i];
        if (
          location.location.name == "All Terrain Cycles" &&
          location.quantity > 0
        ) {
          self.classList.add("show");
          if (variantSupplier == "RALEIGH" || variantSupplier == "HAIBIKE") {
            self.querySelector(".message").innerText =
              window.variantStrings.altStockText;
          } else if (variantSupplier == "TREK") {
            self.querySelector(".message").innerText = location.location.note;
          } else {
            self.querySelector(".message").innerText = location.location.note;
          }
          return;
        } else if (location.quantity > 0) {
          self.classList.add("show");
          if (location.location.name.indexOf("Trek") > -1) {
            self.querySelector(".message").innerText =
              window.variantStrings.trekStockText;
            try {
              document.querySelector(
                ".iia-container .inventoryNote"
              ).innerHTML = `<span class="is"><i class="fa-sharp fa-solid fa-circle-check" aria-hidden="true"></i>In stock at supplier warehouse</span>`;
            } catch (e) {
              console.error("inventory messaging error", e);
            }
            return;
          } else {
            if (variantSupplier == "TREK") {
              self.querySelector(".message").innerText = location.location.note;
            } else {
              self.querySelector(".message").innerText = location.location.note;
            }
            return;
          }
        } else {
          self.classList.remove("show");
        }
      }
    }
  }
  _getLocationObject(variantId) {
    const self = this;
    if (!window.variantLocations) {
      setTimeout(self._setLocationObject.bind(self), 250); 
    } else {
      const arr = window.variantLocations.filter(function (location) {
        return location.variant == variantId;
      });
      return arr[0];
    }
  }
}

customElements.define('product-inventory', ProductInventory);